import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Navigation, Pagination } from 'swiper/modules';

export default function Vod_Box(props) {
  const [swiper, setSwiper] = useState(null);
  let [maxPageCount, setMaxPageCount] = useState(0);
  let [naviCount, setNaviCount] = useState(1);

  useEffect(() => {
    if (swiper != null) {
      swiper.slideTo(0, 0); //TAB 영역 누르면 스와이퍼 초기화
    }

    setMaxPageCount(props.data.contents.length / 4);
  }, []);

  const result = [];
  const datas = props.data.contents;
  for (let i = 0; i <= datas.length - 1; i += 4) {
    result.push(datas.slice(i, i + 4));
  }

  const [touchX, setTouchX] = useState(0);
  const [touchY, setTouchY] = useState(0);

  const touchStart = (e) => {
    setTouchX(e.changedTouches[0].pageX);
    setTouchY(e.changedTouches[0].pageY);
  };

  const touchEnd = (e) => {
    let diffX = touchX - e.changedTouches[0].pageX,
      diffY = touchY - e.changedTouches[0].pageY;

    Math.abs(diffX) > Math.abs(diffY)
      ? 0 < diffX
        ? swiper.slideNext()
        : swiper.slidePrev()
      : 0 < diffY
      ? console.log('to top')
      : console.log('to bottom');
  };
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);
  //link로그를
  const handleClick = (a, b, c, d, e) => {
    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: '큐레이션 모듈', //모듈 아이디 없으면
        moduleTitle: e, //모듈 제목 (Require)
        moduleSubTitle: 'VOD 큐레이션',
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: props.loc_idx, //페이지에서 해당 모듈의 위치
        moduleItemSeq: c, //모듈 내에서 콘텐츠의 위치
        programId: b.pgm_id, //프로그램의 아이디 (추가)
        programTitle: b.pgm_nm, //프로그램의 아이디 (추가)
        contentId: b.mda_id, //식별자
        contentTitle: b.img_attr, //콘텐츠의 제목  (Require)
        contentNumber: '',
        contentType: 'V', //콘텐츠의 타입 (별도 표 참조)
      },
    });
  };

  return (
    <>
      <div className="mainContents-typeWhite">
        <div className="contentsBlock_w">
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.list_title}</h2>
            <a
              href={props.data.alllink_url}
              className="moduleTitleline-linkMore"
              style={{
                visibility:
                  props.data.alllink_yn == 'Y' &&
                  props.data.alllink_url != '' &&
                  props.data.alllink_url != null
                    ? 'visible'
                    : 'hidden',
              }}
            >
              {props.data.alllink_title}
            </a>
          </div>
          <div
            className={'listModule_w_vodCuration2 vodCuration2' + props.loc_idx}
          >
            <Swiper
              onSwiper={(s) => {
                //console.log("initialize swiper", s);
                setSwiper(s);
              }}
              allowTouchMove={false} //수동 제어하기위해 멈춤
              slidesPerView={1}
              spaceBetween={5}
              slidesPerGroup={1}
              loop={false}
              pagination={{
                // 페이징 설정
                el: `.vodCuration2${props.loc_idx} .swiper-pagination`,
                type: `fraction`,
              }}
              breakpoints={{
                375: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                  grid: {
                    rows: 2,
                  },
                },
                768: {
                  slidesPerView: 1,
                  spaceBetween: 0,
                },
              }}
              navigation={{
                nextEl: `.vodCuration2${props.loc_idx} .swiper-button-next`,
                prevEl: `.vodCuration2${props.loc_idx} .swiper-button-prev`,
              }}
              modules={[Autoplay, Pagination, Navigation]}
              className="listModuleSlider"
              wrapperClass="SliderContent"
            >
              {result.map((items, index) => {
                return (
                  <SwiperSlide
                    key={`swiper-slide-${index}`}
                    onTouchStart={touchStart}
                    onTouchEnd={touchEnd}
                  >
                    <div className="listModuleItem swiper-slide">
                      <div className="moduleBoxGroup_w">
                        {items.map((item, index) => {
                          return (
                            <div className="moduleBoxWrap_vod">
                              <Link href={item.link_url}>
                                <a
                                  onClick={(e) =>
                                    handleClick(
                                      e,
                                      item,
                                      index,
                                      '인기',
                                      props.data.list_title
                                    )
                                  }
                                  target={
                                    item.link_new_yn == 'Y' ? '_blank' : ''
                                  }
                                  className="mb_link"
                                >
                                  <div className="mb_image_w">
                                    <span className="iconSvg_play">
                                      <i className="hide">VOD</i>
                                    </span>
                                    <div className="mb_image_inner">
                                      <img
                                        src={item.img_url}
                                        className="mb_image"
                                        alt={item.img_attr}
                                      />
                                    </div>
                                  </div>
                                  <div className="mb_info_w">
                                    <span className="mbif_title">
                                      {item.pgm_nm}
                                    </span>
                                    <div className="mbif_line2">
                                      <span className="mbif_subinfo">
                                        {item.srs_no}회
                                      </span>
                                      <span className="mbif_date">
                                        {item.brd_beg_dd}
                                      </span>
                                    </div>
                                  </div>
                                </a>
                              </Link>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
            <div className="sliderBottom_w">
              <button
                type="button"
                className="btnLineTypeList-Next swiper-button-next"
                onClick={() => setNaviCount(naviCount + 1)}
              >
                <span className="iconSvg_arrow">
                  <i className="hide">다음</i>
                </span>
              </button>
              <div className="swiper-pagination notranslate"></div>
              <button
                type="button"
                aria-label="이전 콘텐츠 보기"
                className="btnLineTypeList-Prev swiper-button-prev"
                onClick={() => setNaviCount(naviCount - 1)}
              >
                <span className="iconSvg_arrow">
                  <i className="hide">이전</i>
                </span>
                <span className="pagingNumber_w">
                  <strong className="pagingNumber-now">{naviCount}</strong>/
                  {maxPageCount}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
